/* eslint-disable prefer-destructuring */
import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import { isEmpty, isNaN, map, isEqual, indexOf, cloneDeep, find } from 'lodash';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
  Modal
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import turf from '@turf/turf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReplayIcon from '@mui/icons-material/Replay';
import SearchIcon from '@mui/icons-material/Search';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';
import * as annotationOps from '../../../api/Annotations/annotation-operations';
import * as templateOps from '../../../api/AnnotationTemplates/annotation-template-operations';
import * as videoCalculate from '../../../api/Videos/videos-calculations';
import * as videoOps from '../../../api/Videos/video-operations';
import * as configOps from '../../../api/ConfigurationsConnectors/configurations-connectors-operations';
import * as sourceOps from '../../../api/Sources/source-operations';
import * as connectorOps from '../../../api/Connectors/connector-operations';
import useTimeStore from '../ZustandProvider';

import Annotations from '../../../api/Annotations/Annotations';
import AnnotationTemplates, {
  ELEMENT_TYPES,
  LIBRARY_ICON_TYPES
} from '../../../api/AnnotationTemplates/AnnotationTemplates';
import CreateRouteOnMap from '../CreateRouteOnMap';
import CreateRouteLocation from '../CreateRouteLocation';
import ImportTrackingAnnotationToVideo from '../ImportTrackingAnnotationToVideo';
import Loading from '../Loading';
import MapsShareByMobile from '../MapsShareByMobile';
import Videos, { VIDEO_COORDINATE_DATA_TYPES } from '../../../api/Videos/Videos';
import ViewAnnotationTemplate from '../../pages/ViewAnnotationTemplate';
import { renderIconButton } from '../MaterialMUIComponent';

import ConfigurationsConnectors from '../../../api/ConfigurationsConnectors/ConfigurationsConnectors';
import Sources from '../../../api/Sources/Sources';
import Connectors from '../../../api/Connectors/Connectors';
import TableSourceComponent from '../TableSourceComponent';

let annotationToSaveId = '';

const LocationComplexComponent = props => {
  const {
    annotationVideo,
    annotationPublic,
    isMobile,
    isPublicMap,
    isloaded,
    locationSettings,
    MapProps,
    userProps,
    videoToSave,
    configConnectorsList,
    annotationTemplatesCustom,
    sourcesList,
    connectorList
  } = props;

  const {
    buttonCurrentLocation,
    buttonToAddImage,
    buttonToAddVideo,
    buttonToAddIframe,
    changeTemplate,
    createAnnotationButton,
    createRouteConfiguration,
    description,
    image,
    intervalTime,
    goToCurrentLocation,
    savingSystem,
    searchAddress,
    sendFirstLocation,
    showAddress,
    showAnnotation,
    showCreateRouteOnMap,
    showImage,
    showName,
    showTracking,
    showTitle,
    showDescription,
    showSharedButton,
    templateConfiguration,
    title,
    trackingAnnotation,
    userNameTitle,
    updatedAnnotation,
    updateAnnotationButton
  } = locationSettings;
  const coordOnMap = useTimeStore(state => state.coordOnMap);
  const setGoToCoordinates = useTimeStore(state => state.setGoToCoordinates);
  const [address, setAddress] = React.useState({});
  const [coordsToShow, setCoordsToShow] = React.useState({});
  const [currentCoords, setCurrentCoords] = React.useState({});

  const fileInputImageRef = React.useRef(null);
  const fileInputVideoRef = React.useRef(null);
  const [loadingComponent, setLoadingComponent] = React.useState(true);
  const [name, setName] = React.useState(userProps.name);
  const [newAnnotation, setNewAnnotation] = React.useState({});
  const [templateSelected, setTemplateSelected] = React.useState({});
  const isAnnotationSharePublic = !!MapProps.match.params.annotation_id;
  const [updatedAnnotationState, setUpdatedAnnotationState] = React.useState(
    isAnnotationSharePublic
  );
  const [openModalDDBB, setOpenModalDDBB] = React.useState(false);
  const [sourceToView, setSourceToView] = React.useState({});
  const configConnectorSelected =
    find(configConnectorsList, item =>
      isEqual(configOps.getTemplateId(item), templateOps.getId(templateSelected))
    ) || {};
  const sourceSelected =
    find(sourcesList, item =>
      isEqual(sourceOps.getId(item), configOps.getSource(configConnectorSelected))
    ) || {};
  const connectorSelected =
    find(connectorList, item =>
      isEqual(sourceOps.getConnectorId(sourceSelected), connectorOps.getId(item))
    ) || {};
  const annotationsTemplatesToRender = videoOps
    .getAnnotationTemplates(videoToSave)
    .concat(annotationTemplatesCustom);

  const changeLocationState = isAnnotationSharePublic && MapProps.match.params.formats[0] === '1';
  const changeLocationFieldsState =
    isAnnotationSharePublic && MapProps.match.params.formats[1] === '1';
  const changeAnnotationState = isAnnotationSharePublic && MapProps.match.params.formats[2] === '1';

  const addDependDataType = (element, value) => {
    if (element.dataType && value) {
      if (element.dataType === 'text' && typeof value !== 'string') {
        return value.toString();
      }
      if (element.dataType === 'number' && typeof value !== 'number') {
        return parseInt(value, 10);
      }
    } else {
      return value;
    }
    return value;
  };

  const fechaAGpsEnMicrosegundos = () => {
    const fechaConHora = new Date();
    const fechaReferenciaGps = new Date('1980-01-06T00:00:00Z');
    const diferencia = fechaConHora.getTime() - fechaReferenciaGps.getTime();
    const diferenciaEnMicroSegundos = diferencia * 1000;
    return diferenciaEnMicroSegundos;
  };

  const obtenerTiempoGpsEnDiasYHora = () => {
    const fechaConHora = new Date();
    const fechaReferenciaGps = new Date('1980-01-06T00:00:00Z');
    const diferenciaMilisegundos = fechaConHora.getTime() - fechaReferenciaGps.getTime();
    const dias = Math.floor(diferenciaMilisegundos / (1000 * 60 * 60 * 24));
    const horasRestantesMilisegundos = diferenciaMilisegundos % (1000 * 60 * 60 * 24);
    const horas = Math.floor(horasRestantesMilisegundos / (1000 * 60 * 60));
    const minutos = Math.floor((horasRestantesMilisegundos % (1000 * 60 * 60)) / (1000 * 60));
    const segundos = Math.floor((horasRestantesMilisegundos % (1000 * 60)) / 1000);
    return `Días: ${dias}, Hora: ${horas}:${minutos
      .toString()
      .padStart(2, '0')}:${segundos.toString().padStart(2, '0')}`;
  };

  const templateConfigurationFunction = (template, addressProp, coordsProp) => {
    let templateConfig = cloneDeep(template);
    if (templateOps.getIsBase(template)) {
      const customAsociated = find(annotationTemplatesCustom, item =>
        isEqual(templateOps.getTemplateBaseId(item), templateOps.getId(template))
      );
      if (!isEmpty(customAsociated)) templateConfig = cloneDeep(customAsociated);
    }
    const configConnector = find(configConnectorsList, item =>
      isEqual(configOps.getTemplateId(item), templateOps.getId(templateConfig))
    );
    const configFields = configOps.getConnectionsFields(configConnector || {});
    const newTemplate = cloneDeep(template);
    if (!isEmpty(configFields)) {
      newTemplate.elements = template.elements.map(element => {
        const matchingElement = cloneDeep(element);

        const matchingConfig = configFields.find(el => {
          return isEqual(configOps.getElementIndex(el), templateOps.getElementOrder(element));
        });
        if (!isEmpty(matchingElement) && !isEmpty(matchingConfig)) {
          if (changeLocationFieldsState === true || isAnnotationSharePublic !== true) {
            if (matchingConfig.value === 'latitud') {
              matchingElement.value = addDependDataType(matchingElement, coordsProp[0]);
            } else if (matchingConfig.value === 'longitud') {
              matchingElement.value = addDependDataType(matchingElement, coordsProp[1]);
            } else if (matchingConfig.value === 'address') {
              matchingElement.value = addDependDataType(matchingElement, addressProp.address);
            } else if (matchingConfig.value === 'country') {
              matchingElement.value = addDependDataType(matchingElement, addressProp.country);
            } else if (matchingConfig.value === 'road') {
              matchingElement.value = addDependDataType(matchingElement, addressProp.road);
            } else if (matchingConfig.value === 'postcode') {
              matchingElement.value = addDependDataType(matchingElement, addressProp.postcode);
            } else if (matchingConfig.value === 'city') {
              matchingElement.value = addDependDataType(matchingElement, addressProp.city);
            }
          }
          if (changeAnnotationState === true || isAnnotationSharePublic !== true) {
            if (matchingConfig.value === 'userId') {
              const newUser = isEmpty(userProps.userId) ? MapProps.map.publicId : userProps.userId;
              matchingElement.value = addDependDataType(matchingElement, newUser);
            } else if (matchingConfig.value === 'userLocalId') {
              matchingElement.value = addDependDataType(matchingElement, userProps.userLocalId.id);
            } else if (matchingConfig.value === 'userLocalName') {
              matchingElement.value = addDependDataType(
                matchingElement,
                userProps.userLocalId.name
              );
            } else if (matchingConfig.value === 'mapId') {
              matchingElement.value = addDependDataType(matchingElement, MapProps.map._id);
            } else if (matchingConfig.value === 'fecha') {
              matchingElement.value = addDependDataType(
                matchingElement,
                new Date().toLocaleDateString()
              );
            } else if (matchingConfig.value === 'hora') {
              matchingElement.value = addDependDataType(
                matchingElement,
                new Date().toLocaleTimeString()
              );
            } else if (matchingConfig.value === 'tiempoGPS') {
              matchingElement.value = addDependDataType(
                matchingElement,
                fechaAGpsEnMicrosegundos()
              );
            } else if (matchingConfig.value === 'tiempoGPSView') {
              matchingElement.value = addDependDataType(
                matchingElement,
                obtenerTiempoGpsEnDiasYHora()
              );
            }
          }
        }
        return matchingElement;
      });
    }
    return newTemplate;
  };

  const videoTimeFunction = currentTimeGPS => {
    let time = 0;
    if (savingSystem === 'incremental') {
      const numerosVideotime = !isEmpty(annotationVideo)
        ? annotationVideo.map(objeto => objeto.geoJSON.properties.videoTime)
        : [0];
      time = Math.max(...numerosVideotime) + parseInt(intervalTime, 10) * 1000000;
    } else if (savingSystem === 'location') {
      const coordenadas = isEmpty(coordOnMap)
        ? [currentCoords.lng, currentCoords.lat]
        : [coordOnMap.lng, coordOnMap.lat];
      const newPointTurf = turf.point(coordenadas);
      if (videoToSave.coordinatesDataType === 'point') {
        const numerosVideotime = !isEmpty(annotationVideo)
          ? annotationVideo.map(objeto => objeto.geoJSON.properties.videoTime)
          : [0];
        time = Math.max(...numerosVideotime) + 1 * 1000000;
      } else {
        const newPointVideo = turf.nearestPointOnLine(videoToSave.track, newPointTurf);
        time = videoCalculate.calculateTimeVideoLine(videoToSave, newPointVideo, annotationVideo);
      }
    } else if (savingSystem === 'gpsTime') {
      const numerosTimeGPS = !isEmpty(annotationVideo)
        ? annotationVideo.map(objeto => objeto.timeGPS)
        : [0];
      const initialTimeGPS = Math.min(...numerosTimeGPS);
      time =
        initialTimeGPS !== 0 && !isNaN(initialTimeGPS)
          ? currentTimeGPS - initialTimeGPS
          : currentTimeGPS;
    } else {
      time += 5 * 1000000;
    }
    return time;
  };

  const vaciarTemplate = template => {
    template.elements.forEach(item => {
      if (
        item.elementType === ELEMENT_TYPES.MULTIPLEIFRAME ||
        item.elementType === ELEMENT_TYPES.MULTIPLEVIDEOS ||
        item.elementType === ELEMENT_TYPES.MULTIPLEPICTURES
      ) {
        // eslint-disable-next-line no-param-reassign
        item.multiValues = [];
      } else if (item.elementType === ELEMENT_TYPES.MULTIPLEIMAPS) {
        // eslint-disable-next-line no-param-reassign
        item.multipleMaps = [];
      } else if (item.elementType === ELEMENT_TYPES.MULTIPLEPOINTCLOUD) {
        // eslint-disable-next-line no-param-reassign
        item.multiplePointCloud = [];
      } else {
        // eslint-disable-next-line no-param-reassign
        item.value = '';
      }
    });
    return template;
  };

  const createAnnotation = async (item, coordinates) => {
    if (updatedAnnotationState === true && isAnnotationSharePublic === true) {
      annotationToSaveId = MapProps.match.params.annotation_id;
    } else if (updatedAnnotationState !== true) {
      annotationToSaveId = Array.from({ length: 18 }, () => Math.random().toString(36)[2]).join('');
    }
    const userId = isPublicMap === true ? userProps.userLocalId.id : userProps.userId;
    try {
      if (isEmpty(item)) throw new Error('No annotation template selected.');
      const templateAnnotation = cloneDeep(item);
      if (userNameTitle && userNameTitle === true) {
        templateAnnotation.name = !isEmpty(name) ? name : item.name;
      }
      const currentTimeGPS = fechaAGpsEnMicrosegundos();
      const videoTimeValue = videoTimeFunction(currentTimeGPS);
      const videoPosition =
        newAnnotation && !isEmpty(annotationOps.getVideoPosition(newAnnotation))
          ? annotationOps.getVideoPosition(newAnnotation)
          : { x: 370.75, y: 137, width: 549, height: 309 };
      const isVideoPoint = videoToSave.coordinatesDataType === VIDEO_COORDINATE_DATA_TYPES.POINT;
      const annotationToSave = {
        geoJSON: {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates:
              isAnnotationSharePublic !== true || changeLocationState === true
                ? [coordinates[1], coordinates[0]]
                : annotationOps.getCoordinates(annotationToSaveId)
          },
          properties: {
            template: templateAnnotation,
            video: videoToSave._id,
            videoTime: parseInt(videoTimeValue, 10),
            videoPosition,
            isProyected: !isVideoPoint,
            alias: !isEmpty(name) ? name : '',
            mapID: MapProps.map._id
          }
        },
        origin: 'manual',
        isTracking: trackingAnnotation
      };

      if (updatedAnnotationState === true) {
        await methodPromise(
          'annotations.updateWithLocation',
          { ...annotationToSave, _id: annotationToSaveId },
          true,
          userId
        );
        Bert.alert('Annotation updated', 'success');
      } else {
        await methodPromise(
          'annotations.insert',
          { ...annotationToSave, owner: userId, _id: annotationToSaveId },
          isPublicMap,
          userId
        );
        Bert.alert('Annotation created', 'success');
        if (updatedAnnotation === true) {
          setUpdatedAnnotationState(true);
        } else {
          const newTemplate = vaciarTemplate(templateSelected);
          setTemplateSelected({});
          setTemplateSelected(newTemplate);
          setNewAnnotation(newTemplate);
        }
      }
      if (trackingAnnotation && trackingAnnotation === true) {
        const trackingAnnotationToSave = {
          ...annotationToSave,
          currentCoordinates: [currentCoords[1], currentCoords[0]],
          annotationId: annotationToSaveId
        };
        await methodPromise(
          'trackingAnnotations.insert',
          trackingAnnotationToSave,
          isPublicMap,
          userId
        );
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const updateAnnotationSelected = annotation => {
    const templateAnnotation = annotationOps.getTemplate(annotation);
    setTemplateSelected(templateAnnotation);
    setNewAnnotation(annotation);
  };

  const startNewAnnotation = () => {
    if (updatedAnnotationState === true) {
      setNewAnnotation(annotationPublic);
    } else {
      const templateAnnotation = cloneDeep(templateSelected);
      if (userNameTitle && userNameTitle === true) {
        templateAnnotation.name = name;
      }
      const currentTimeGPS = fechaAGpsEnMicrosegundos();
      const videoTimeValue = videoTimeFunction(currentTimeGPS);
      const newAnnotationState = {
        geoJSON: {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: coordsToShow
          },
          properties: {
            video: videoToSave._id,
            videoTime: parseInt(videoTimeValue, 10),
            videoPosition: {
              x: 370.75,
              y: 137,
              width: 549,
              height: 309
            },
            template: templateAnnotation,
            isProyected: false
          },
          mapID: MapProps.map._id,
          alias: isEmpty(name) ? '' : name
        },
        origin: 'manual',
        owner: isEmpty(userProps.userId) ? userProps.userLocalId.id : userProps.userId.id,
        isTracking: trackingAnnotation
      };
      setNewAnnotation(newAnnotationState);
    }
  };

  const renderButtons = buttonConfig => {
    if (!isEmpty(buttonConfig.libraryIcon)) {
      if (buttonConfig.libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME) {
        return <FontAwesomeIcon icon={buttonConfig.iconFontawesome} size="lg" />;
      }
      if (buttonConfig.libraryIcon === LIBRARY_ICON_TYPES.SVG) {
        return (
          <img
            src={buttonConfig.iconSvg}
            alt={buttonConfig.iconFontawesome}
            style={{ marginRight: '5px', width: '20px', height: '20px' }}
          />
        );
      }
    }

    return '';
  };

  const obtenerUbicacion = async () => {
    if ('geolocation' in navigator) {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          position => {
            const latitud = position.coords.latitude;
            const longitud = position.coords.longitude;
            const coordenadas = [latitud, longitud];
            setCurrentCoords(coordenadas);
            resolve(coordenadas);
          },
          error => {
            switch (error.code) {
              case error.PERMISSION_DENIED:
                Bert.alert('El usuario denegó la solicitud de geolocalización.', 'warning');
                break;
              case error.POSITION_UNAVAILABLE:
                reject(new Error('La información de la ubicación no está disponible.'));
                break;
              case error.TIMEOUT:
                reject(new Error('Se ha agotado el tiempo de espera para obtener la ubicación.'));
                break;
              case error.UNKNOWN_ERROR:
                reject(new Error('Se produjo un error desconocido al obtener la ubicación.'));
                break;
              default:
                reject(new Error('Se produjo un error desconocido al obtener la ubicación.'));
                break;
            }
          }
        );
      });
    }
    return Promise.reject(new Error('La geolocalización no está soportada por este navegador.'));
  };

  const addressCordinates = async () => {
    if (!isEmpty(address)) {
      const response = await fetch(
        'https://sd1.ipsgeoprocesing.ipsilum.com/MG/geolocation/exec_geocodificacion',
        {
          method: 'POST',
          body: JSON.stringify({
            direction: address.address
          }),
          headers: { 'Content-Type': 'application/json' },
          mode: 'cors',
          credentials: 'omit',
          referrerPolicy: 'no-referrer'
        }
      );
      const respuesta = await response.json();
      if (respuesta.point) {
        const coordinates = [parseInt(respuesta.point[0], 10), parseInt(respuesta.point[1], 10)];
        setGoToCoordinates(coordinates);
        setCoordsToShow(coordinates);
        if (templateConfiguration.configuration && templateConfiguration.configuration === true) {
          const updatedTemplateSelected = templateConfigurationFunction(
            templateSelected,
            address,
            coordinates
          );
          setTemplateSelected({});
          setTemplateSelected(updatedTemplateSelected);
          startNewAnnotation(updatedTemplateSelected);
        }
      } else {
        setCoordsToShow([]);
        Bert.alert(respuesta, 'info');
      }
    }
  };

  const coordinatesAddress = async coordinates => {
    if (!isEmpty(coordinates)) {
      try {
        const response = await fetch(
          'https://sd1.ipsgeoprocesing.ipsilum.com/MG/geolocation/exec_geocodificacion',
          {
            method: 'POST',
            body: JSON.stringify({
              point: coordinates
            }),
            headers: { 'Content-Type': 'application/json' },
            mode: 'cors',
            credentials: 'omit',
            referrerPolicy: 'no-referrer'
          }
        );
        const respuesta = await response.json();
        if (respuesta) {
          setAddress(respuesta);
          return respuesta;
        }
        setAddress('');
        return '';
      } catch (error) {
        console.error('Error al obtener la dirección:', error);
        return '';
      }
    }
    return '';
  };

  const updateAnnotationFields = (elementItem, property, newValue) => {
    const newFieldsTemplate = cloneDeep(templateSelected);
    const templateElementsArray = templateOps.getElements(newFieldsTemplate);
    const elementUpdate = find(templateElementsArray, element => isEqual(element, elementItem));
    const newElementTemplate = map(templateElementsArray, element => {
      const newElement = element;
      if (
        isEqual(
          indexOf(templateElementsArray, element),
          indexOf(templateElementsArray, elementUpdate)
        )
      ) {
        newElement[property] = newValue;
      }
      return newElement;
    });
    newFieldsTemplate.elements = newElementTemplate;
    setTemplateSelected(newFieldsTemplate);
  };
  // UploadFileComponent --> archivo de subir cosas
  const loadFileToBack = async file => {
    if (!file) {
      Bert.alert('Please select a file first', 'danger');
      return ''; // Return empty string for consistency
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('disc', 'data3');
    try {
      const response = await fetch('https://sd1.d3.ipsilum.com/upload', {
        method: 'POST',
        body: formData,
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });

      if (!response.ok) {
        Bert.alert(`Error: Server responded with status ${response.status}`, 'warning');
        return '';
      }
      const respuesta = await response.json();
      if (respuesta.status === 'OK') {
        Bert.alert('File uploaded successfully!', 'success');
        return respuesta;
      }
      Bert.alert('Please upload the file again', 'warning');
      return '';
    } catch (error) {
      Bert.alert('An error occurred while uploading the file. Please try again.', 'danger');
      console.error('Error:', error);
      return '';
    }
  };

  const loadIAPicture = async (type, url) => {
    let body;
    if (type === 'video') {
      body = JSON.stringify({
        video: url
      });
    } else if (type === 'imagen') {
      body = JSON.stringify({
        imagen: url
      });
    } else if (type === 'iframe') {
      body = JSON.stringify({
        pdf: url
      });
    }
    try {
      const response = await fetch(
        'https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/image_files',
        {
          method: 'POST',
          body,
          mode: 'cors',
          credentials: 'omit',
          referrerPolicy: 'no-referrer'
        }
      );
      const respuesta = await response.json();
      return respuesta;
    } catch (error) {
      Bert.alert('An error occurred while uploading the file. Please try again.', 'danger');
      console.error('Error:', error);
    }
    return '';
  };

  const postDataConnection = async (connection, sourceTableName, data) => {
    const { user, databaseName, ip, port, password, schema } = connection;
    const serverToConnection = {
      user,
      ip,
      port,
      databaseName,
      password,
      schema,
      tableName: sourceTableName
    };
    try {
      const response = await fetch(
        'https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/upload_to_database',
        {
          method: 'POST',
          body: JSON.stringify({
            connection: serverToConnection,
            data
          }),
          headers: { 'Content-Type': 'application/json' }
        }
      );
      const answer = await response.json();
      if (typeof answer === 'string') {
        if (answer.includes('error')) {
          Bert.alert('There have been an error saving data in db ', 'danger');
        } else {
          Bert.alert('Data saved succesfully', 'success');
        }
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  const uploadDataToDataBase = (templateSelect, configSelect, connectionSelect, sourceSelect) => {
    const sourceTableName = sourceOps.getLayerName(sourceSelect || {});
    const newData = map(configOps.getConnectionsFields(configSelect), config => {
      const elementTemplate = find(templateOps.getElements(templateSelect), el =>
        isEqual(templateOps.getElementOrder(el), configOps.getElementAsociatedIndex(config))
      );
      let valueToSave = templateOps.getElementValue(elementTemplate);
      if (isEqual(configOps.getValue(config), 'labelName'))
        valueToSave = templateOps.getElementLabelName(elementTemplate);
      if (isEqual(configOps.getValue(config), 'hiperLink'))
        valueToSave = templateOps.getElementHiperLink(elementTemplate);
      return { [configOps.getNameField(config)]: valueToSave };
    });
    if (!isEmpty(connectionSelect) && !isEmpty(sourceTableName) && !isEmpty(newData))
      postDataConnection(connectionSelect, sourceTableName, newData);
  };

  React.useEffect(() => {
    const handleCoordinatesAddress = async coordinates => {
      try {
        return await coordinatesAddress(coordinates);
      } catch (error) {
        console.error('No se encuentra la dirección seleccionada.', error);
        throw error;
      }
    };

    const firstRender = async () => {
      if (!isloaded) return;

      try {
        const coordinates = await obtenerUbicacion();
        setCoordsToShow(coordinates);

        let newTemplate = {};

        // Validación para evitar problemas en `defaultTemplate`
        const defaultTemplate = videoToSave.annotationTemplates
          .concat(annotationTemplatesCustom)
          .find(index => index._id === locationSettings.defaultTemplate);
        if (!defaultTemplate) {
          console.error('defaultTemplate no encontrado:', locationSettings.defaultTemplate);
          throw new Error('defaultTemplate no encontrado');
        }

        if (updatedAnnotationState) {
          if (isAnnotationSharePublic && annotationPublic) {
            // Validar valores de `annotationPublic`
            if (
              !annotationPublic.geoJSON.properties.template._id ||
              !videoToSave.annotationTemplates
            ) {
              console.error('Datos incompletos en annotationPublic o templates');
              throw new Error('Datos incompletos en annotationPublic o templates');
            }

            // Validación para evitar problemas en `newTemplate`
            newTemplate = videoToSave.annotationTemplates
              .concat(annotationTemplatesCustom)
              .find(index => index._id === annotationPublic.geoJSON.properties.template._id);
            if (!newTemplate) {
              console.error(
                'newTemplate no encontrado para el ID:',
                annotationPublic.geoJSON.properties.template._id
              );
              throw new Error('newTemplate no encontrado');
            }
          }

          if (showAddress) {
            await handleCoordinatesAddress(coordinates);
          }
        } else {
          const baseTemplate = vaciarTemplate(defaultTemplate);

          if (showAddress) {
            const newAddress = await handleCoordinatesAddress(coordinates);

            newTemplate = templateConfiguration.configuration
              ? templateConfigurationFunction(baseTemplate, newAddress, coordinates)
              : cloneDeep(baseTemplate);
          } else {
            newTemplate = templateConfiguration.configuration
              ? templateConfigurationFunction(baseTemplate, address, coordinates)
              : cloneDeep(baseTemplate);
          }
        }

        // Setear el template seleccionado y manejar estados adicionales
        setTemplateSelected(newTemplate);
        startNewAnnotation(newTemplate);

        if (sendFirstLocation) createAnnotation(newTemplate, coordinates);
        if (goToCurrentLocation) setGoToCoordinates(coordinates);

        setLoadingComponent(false);
      } catch (error) {
        console.error('Error durante la inicialización:', error);
      }
    };

    firstRender();
  }, [isloaded]);

  React.useEffect(() => {
    const newFunction = async () => {
      let newAdress = address;
      const coordinates = [coordOnMap.lat, coordOnMap.lng];
      if (
        !isEmpty(coordinates) &&
        typeof coordinates[0] === 'number' &&
        typeof coordinates[1] === 'number'
      ) {
        setCoordsToShow(coordinates);
        if (showAddress && showAddress === true) {
          newAdress = await coordinatesAddress(coordinates);
        }
        if (templateConfiguration.configuration && templateConfiguration.configuration === true) {
          const updatedTemplateSelected = templateConfigurationFunction(
            templateSelected,
            newAdress,
            coordinates
          );
          setTemplateSelected({});
          setTemplateSelected(updatedTemplateSelected);
          startNewAnnotation(updatedTemplateSelected);
        }
      }
    };
    newFunction();
  }, [coordOnMap]);

  return (
    <>
      {loadingComponent === true ? (
        <Loading />
      ) : (
        <Box display="flex" flexDirection="column" gap={2} overflowy="hidden" sx={{ m: 1 }}>
          {showTitle && showTitle === true && (
            <Typography align="center" sx={{ color: 'black', fontFamily: 'Arial' }} variant="h3">
              {title}
            </Typography>
          )}
          {showImage && showImage === true && isMobile !== true && (
            <>
              {image && !isEmpty(image) && (
                <Box
                  sx={{
                    alignSelf: 'center',
                    mb: 1,
                    maxHeight: '20%',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                >
                  <img
                    src={image}
                    alt="imagen"
                    style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                  />
                </Box>
              )}
            </>
          )}
          <Box display="flex" flexDirection="row" gap={2}>
            <Tooltip title={buttonCurrentLocation.name}>
              <Button
                onClick={async () => {
                  const coordinates = await obtenerUbicacion();
                  setCoordsToShow(coordinates);
                  setGoToCoordinates(coordinates);
                  if (showAddress && showAddress === true) {
                    coordinatesAddress(coordinates);
                  }
                }}
              >
                {buttonCurrentLocation.icon
                  ? buttonCurrentLocation.icon
                  : renderButtons(buttonCurrentLocation)}
              </Button>
            </Tooltip>

            {templateConfiguration.configuration === true && showAnnotation === true && (
              <Tooltip title="Reload template">
                <Button
                  onClick={() => {
                    vaciarTemplate(templateSelected);
                    const newTemplate = vaciarTemplate(templateSelected);
                    const updatedTemplateSelected = templateConfigurationFunction(
                      newTemplate,
                      address,
                      coordsToShow
                    );
                    setTemplateSelected({});
                    setTemplateSelected(updatedTemplateSelected);
                    startNewAnnotation(updatedTemplateSelected);
                  }}
                >
                  <ReplayIcon style={{ color: '#2A3F90' }} />
                </Button>
              </Tooltip>
            )}

            {showTracking && showTracking === true && (
              <ImportTrackingAnnotationToVideo isPublicMap={isPublicMap} />
            )}
            {buttonToAddImage && buttonToAddImage.show === true && !isEmpty(templateSelected) && (
              <>
                {templateSelected.elements.some(
                  el => el.elementType === ELEMENT_TYPES.MULTIPLEPICTURES
                ) && (
                  <>
                    <Tooltip title={buttonToAddImage.name}>
                      <Button
                        variant="outlined"
                        sx={{
                          color: '#2A3F90',
                          backgroundColor: 'white',
                          borderColor: '#2A3F90'
                        }}
                        onClick={() => {
                          fileInputImageRef.current.click();
                        }}
                        size="small"
                      >
                        {buttonToAddImage.icon
                          ? buttonToAddImage.icon
                          : renderButtons(buttonToAddImage)}
                      </Button>
                    </Tooltip>
                    <input
                      ref={fileInputImageRef}
                      type="file"
                      style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                      onChange={async event => {
                        const respuesta = await loadFileToBack(event.target.files[0]);
                        const updatedTemplate = {
                          ...templateSelected,
                          elements: templateSelected.elements.map(el => {
                            if (el.elementType === ELEMENT_TYPES.MULTIPLEPICTURES) {
                              const newObject = {
                                url: respuesta.data.link,
                                name: `Image${el.multiValues ? el.multiValues.length + 1 : 1}`
                              };

                              return {
                                ...el,
                                multiValues: Array.isArray(el.multiValues)
                                  ? [...el.multiValues, newObject]
                                  : [newObject]
                              };
                            }
                            return el;
                          })
                        };
                        setTemplateSelected({});
                        setTemplateSelected(updatedTemplate);
                        startNewAnnotation(updatedTemplate);
                      }}
                    />
                  </>
                )}
              </>
            )}
            {buttonToAddVideo && buttonToAddVideo.show === true && !isEmpty(templateSelected) && (
              <>
                {templateSelected.elements.some(
                  el => el.elementType === ELEMENT_TYPES.MULTIPLEVIDEOS
                ) && (
                  <>
                    <Tooltip title={buttonToAddVideo.name}>
                      <Button
                        variant="outlined"
                        sx={{
                          color: '#2A3F90',
                          backgroundColor: 'white',
                          borderColor: '#2A3F90'
                        }}
                        onClick={() => {
                          fileInputVideoRef.current.click();
                        }}
                        size="small"
                      >
                        {buttonToAddVideo.icon
                          ? buttonToAddVideo.icon
                          : renderButtons(buttonToAddVideo)}
                      </Button>
                    </Tooltip>
                    <input
                      ref={fileInputVideoRef}
                      type="file"
                      style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                      onChange={async event => {
                        const respuesta = await loadFileToBack(event.target.files[0]);
                        const imagen = await loadIAPicture('video', respuesta.data.link);
                        const updatedTemplate = {
                          ...templateSelected,
                          elements: templateSelected.elements.map(el => {
                            if (el.elementType === ELEMENT_TYPES.MULTIPLEVIDEOS) {
                              const newObject = {
                                url: respuesta.data.link,
                                name: `Video${el.multiValues ? el.multiValues.length + 1 : 1}`,
                                imgLink: imagen
                              };
                              return {
                                ...el,
                                multiValues: Array.isArray(el.multiValues)
                                  ? [...el.multiValues, newObject]
                                  : [newObject]
                              };
                            }
                            return el;
                          })
                        };
                        setTemplateSelected({});
                        setTemplateSelected(updatedTemplate);
                        startNewAnnotation(updatedTemplate);
                      }}
                    />
                  </>
                )}
              </>
            )}
            {buttonToAddIframe && buttonToAddIframe.show === true && !isEmpty(templateSelected) && (
              <>
                {templateSelected.elements.some(
                  el => el.elementType === ELEMENT_TYPES.MULTIPLEIFRAME
                ) && (
                  <>
                    <Tooltip title={buttonToAddIframe.name}>
                      <Button
                        variant="outlined"
                        sx={{
                          color: '#2A3F90',
                          backgroundColor: 'white',
                          borderColor: '#2A3F90'
                        }}
                        onClick={() => {
                          fileInputVideoRef.current.click();
                        }}
                        size="small"
                      >
                        {buttonToAddIframe.icon
                          ? buttonToAddIframe.icon
                          : renderButtons(buttonToAddIframe)}
                      </Button>
                    </Tooltip>
                    <input
                      ref={fileInputVideoRef}
                      type="file"
                      style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                      onChange={async event => {
                        const respuesta = await loadFileToBack(event.target.files[0]);
                        const updatedTemplate = {
                          ...templateSelected,
                          elements: templateSelected.elements.map(el => {
                            if (el.elementType === ELEMENT_TYPES.MULTIPLEIFRAME) {
                              const newObject = {
                                url: respuesta.data.link,
                                name: `Iframe${el.multiValues ? el.multiValues.length + 1 : 1}`
                              };
                              return {
                                ...el,
                                multiValues: Array.isArray(el.multiValues)
                                  ? [...el.multiValues, newObject]
                                  : [newObject]
                              };
                            }
                            return el;
                          })
                        };
                        setTemplateSelected({});
                        setTemplateSelected(updatedTemplate);
                        startNewAnnotation(updatedTemplate);
                      }}
                    />
                  </>
                )}
              </>
            )}
            {isAnnotationSharePublic !== true && showSharedButton === true && (
              <MapsShareByMobile annotationVideo={annotationVideo} {...props} />
            )}
          </Box>
          {((showAddress && showAddress === true) || (searchAddress && searchAddress === true)) && (
            <Box
              component="form"
              sx={{
                display: 'flex',
                mb: 2,
                width: '100%'
              }}
              noValidate
              autoComplete="off"
            >
              <TextField
                id="outlined-required"
                fullWidth
                focused
                label="Seach address"
                size="small"
                value={address.address}
                onChange={event => setAddress({ ...address, address: event.target.value })}
                InputProps={{
                  readOnly: !searchAddress,
                  endAdornment: searchAddress === true && (
                    <InputAdornment position="end">
                      <IconButton
                        variant="contained"
                        aria-label="upload"
                        component="label"
                        style={{
                          color: '#2A3F90'
                        }}
                        onClick={() => {
                          addressCordinates();
                        }}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Box>
          )}
          {showDescription && showDescription === true && (
            <Typography>
              {/* eslint-disable-next-line react/no-danger */}
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </Typography>
          )}
          {showName && showName === true && (
            <TextField
              id="outlined-required"
              label="Name"
              size="small"
              sx={{ mb: 2 }}
              value={name}
              onChange={event => setName(event.target.value)}
              fullWidth
            />
          )}
          {createRouteConfiguration && createRouteConfiguration.show === true && (
            <CreateRouteLocation
              createRouteConfiguration={createRouteConfiguration}
              coordinates={coordsToShow}
            />
          )}
          {showCreateRouteOnMap && showCreateRouteOnMap === true && (
            <CreateRouteOnMap defaultType={createRouteConfiguration.mode} />
          )}
          {changeTemplate && changeTemplate === true && updatedAnnotationState !== true && (
            <>
              {videoToSave && !isEmpty(videoToSave) && (
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel id="demo-select-label">Template</InputLabel>
                  <Select
                    labelId="demo-select-label"
                    id="demo-select"
                    label="Template"
                    size="small"
                    value={templateOps.getId(templateSelected)}
                    onChange={event => {
                      const newTemplateSelected = annotationsTemplatesToRender.find(
                        index => index._id === event.target.value
                      );
                      const emptyTemplate = vaciarTemplate(newTemplateSelected);
                      const updatedTemplateSelected = templateConfigurationFunction(
                        emptyTemplate,
                        address,
                        coordsToShow
                      );
                      setTemplateSelected(updatedTemplateSelected);
                      startNewAnnotation(updatedTemplateSelected);
                    }}
                  >
                    {annotationsTemplatesToRender.map(item => (
                      <MenuItem key={item._id} value={item._id}>
                        {templateOps.getIsBase(item) ? item.name : `${item.name}-custom`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </>
          )}
          {templateConfiguration.previewDataBase && !isEmpty(sourcesList) && (
            <Stack direction="row" display="flex">
              <FormControl fullWidth sx={{ mr: 1 }}>
                <InputLabel id="demo-select-label">Select Source to view</InputLabel>
                <Select
                  labelId="demo-select-label"
                  id="demo-select"
                  label="Select Source to view"
                  size="small"
                  value={templateOps.getId(sourceToView)}
                  onChange={event => {
                    const newSource = sourcesList.find(index => index._id === event.target.value);
                    setSourceToView(newSource);
                  }}
                >
                  {sourcesList.map(item => (
                    <MenuItem key={item._id} value={item._id}>
                      {sourceOps.getName(item)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {!isEmpty(sourceToView) &&
                renderIconButton({
                  key: 'open-connection-dataBase',
                  icon: <FontAwesomeIcon icon="database" />,
                  onClick: () => setOpenModalDDBB(true),
                  titleTooltip: 'Open DDBB Connections'
                })}
              {!isEmpty(sourceToView) && (
                <Modal open={openModalDDBB} onClose={() => setOpenModalDDBB(false)}>
                  <Box
                    style={{
                      zIndex: 1800,
                      position: 'absolute',
                      backgroundColor: 'white',
                      height: '90%',
                      width: '90%',
                      top: '5%',
                      left: '5%'
                    }}
                  >
                    <Stack
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      marginTop="1%"
                      marginLeft="1%"
                      marginBottom="2%"
                      marginRight="1%"
                    >
                      <Stack direction="column">
                        <Typography
                          key="title-header"
                          sx={{ color: 'black', fontFamily: 'Arial' }}
                          variant="h4"
                        >
                          {sourceOps.getName(sourceToView)} DB
                        </Typography>
                      </Stack>
                      <Stack direction="column">
                        <Stack
                          key="row-buttons-header"
                          direction="row"
                          display="flex"
                          width="95%"
                          justifyContent="flex-end"
                        >
                          {renderIconButton({
                            key: 'Close-button-tempalte-config',
                            onClick: () => setOpenModalDDBB(false),
                            icon: <CloseIcon />,
                            titleTooltip: 'Close configuration templates',
                            style: { color: 'red' }
                          })}
                        </Stack>
                      </Stack>
                    </Stack>
                    <TableSourceComponent
                      isExternalSources
                      startConnector={
                        find(connectorList, item =>
                          isEqual(connectorOps.getId(item), sourceOps.getConnectorId(sourceToView))
                        ) || {}
                      }
                      externalSource={sourceOps.getId(sourceToView)}
                      externalAttributes={sourceOps.getAttributes(sourceToView)}
                      sqlQuery={sourceOps.getSQLQuery(sourceToView)}
                      limitData={templateConfiguration.limitDataConsulting}
                    />
                  </Box>
                </Modal>
              )}
            </Stack>
          )}
          {!isEmpty(templateSelected) && showAnnotation && showAnnotation === true && (
            <Box marginLeft="5%" marginRight="5%">
              <ViewAnnotationTemplate
                selectedTemplate={templateOps.getId(templateSelected)}
                annotationTemplate={templateSelected}
                updateAnnotationFields={updateAnnotationFields}
                startingPreviewMode="edition"
                video={videoToSave}
                height="40vh"
                isShowButtons={false}
                isConnectionTemplate={false}
                updatedAnnotation={newAnnotation}
                updateAnnotationSelected={updateAnnotationSelected}
                {...props}
              />
            </Box>
          )}
          <Box height="5vh">
            <Stack
              direction="row"
              display="flex"
              justifyContent="flex-end"
              marginTop="2%"
              marginRight="4%"
            >
              <Button
                variant="outlined"
                color="success"
                size="small"
                onClick={() => createAnnotation(templateSelected, coordsToShow)}
              >
                {updatedAnnotationState === true ? updateAnnotationButton : createAnnotationButton}
              </Button>
              {templateConfiguration.isSaveDataBase && (
                <Button
                  variant="outlined"
                  size="small"
                  style={{ marginLeft: '2%', color: '#2A3F90 ' }}
                  onClick={() =>
                    uploadDataToDataBase(
                      templateSelected,
                      configConnectorSelected,
                      connectorSelected,
                      sourceSelected
                    )
                  }
                >
                  Save in DB
                </Button>
              )}
            </Stack>
          </Box>
        </Box>
      )}
    </>
  );
};

export default withTracker(({ locationSettings, MapProps }) => {
  const { videoId, templateConfiguration } = locationSettings;
  const { annotationId } = MapProps.match.params;
  let configConnectorsSub = {};
  let configConnectorsList = [];
  let sourcesList = [];
  let connectorList = [];
  let annotationTemplatesCustom = [];

  const videosSub = Meteor.subscribe('videos.annotations', videoId);

  const videoToSave = Videos.findOne({ _id: videoId, deleted: { $eq: 'no' } });
  const annotationVideo = Annotations.find({}, { sort: { videoTime: 1 } }).fetch();

  if (!isEmpty(templateConfiguration.configConnection)) {
    configConnectorsSub = Meteor.subscribe('configConnector.customTemplates.videos', [videoId]);
    configConnectorsList = ConfigurationsConnectors.find({}, { sort: { name: 1 } }).fetch();
    annotationTemplatesCustom = AnnotationTemplates.find({}, { sort: { name: 1 } }).fetch();
    sourcesList = Sources.find({}, { sort: { name: 1 } }).fetch();
    connectorList = Connectors.find({}, { sort: { name: 1 } }).fetch();
  }

  let annotationPublic = {};
  let annotationPublicSub = null;
  if (annotationId) {
    annotationPublicSub = Meteor.subscribe('annotations.onePublic', annotationId);
    annotationPublic = Annotations.findOne({
      _id: annotationId
    });
  }
  const configSubReady = !isEmpty(configConnectorsSub) ? configConnectorsSub.ready() : true;
  const isloaded =
    videosSub.ready() &&
    configSubReady &&
    (!annotationId || (annotationPublicSub.ready() && !isEmpty(annotationPublic))) &&
    !!videoToSave;

  return {
    annotationVideo,
    isloaded,
    videoToSave,
    annotationPublic,
    configConnectorsList,
    annotationTemplatesCustom,
    sourcesList,
    connectorList
  };
})(LocationComplexComponent);

LocationComplexComponent.defaultProps = {
  annotationPublic: {},
  annotationVideo: [],
  isMobile: false,
  isPublicMap: false,
  isloaded: false,
  MapProps: {},
  userProps: {},
  videoToSave: {},
  configConnectorsList: [],
  annotationTemplatesCustom: [],
  sourcesList: [],
  connectorList: []
};
LocationComplexComponent.propTypes = {
  annotationPublic: PropTypes.object,
  annotationVideo: PropTypes.array,
  isMobile: PropTypes.bool,
  isPublicMap: PropTypes.bool,
  isloaded: PropTypes.bool,
  locationSettings: PropTypes.object.isRequired,
  MapProps: PropTypes.object,
  userProps: PropTypes.object,
  videoToSave: PropTypes.object,
  configConnectorsList: PropTypes.array,
  annotationTemplatesCustom: PropTypes.array,
  sourcesList: PropTypes.array,
  connectorList: PropTypes.array
};
